import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <section className="panel" aria-labelledby="not-found-title">
      <h1 id="not-found-title">Không tìm thấy trang</h1>
      <p className="lead">Địa chỉ có thể đã thay đổi hoặc nội dung không còn tồn tại.</p>
      <div className="hero-actions">
        <Link className="btn" to="/">
          Về trang chủ
        </Link>
        <Link className="btn btn-quiet" to="/thu-vien">
          Mở thư viện
        </Link>
      </div>
    </section>
  );
}
